export interface ISurveysStore {
  currentSurvey?: any;
  surveys: any[];
}

export const surveysStore = {
  currentSurvey: undefined,
  surveys: [],
};
